import { render, staticRenderFns } from "./RoleClaims.vue?vue&type=template&id=ae011ede&"
import script from "./RoleClaims.vue?vue&type=script&lang=js&"
export * from "./RoleClaims.vue?vue&type=script&lang=js&"
import style0 from "./RoleClaims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports